<template>
    <q-footer elevated class="bg-grey-8 text-white">
        <q-toolbar>
            <q-toolbar-title>
                <q-avatar>
                    <img src="https://cdn.quasar.dev/logo-v2/svg/logo-mono-white.svg">
                </q-avatar>
                <div>Title</div>
            </q-toolbar-title>
        </q-toolbar>
    </q-footer>


</template>


<style>
</style>

<script>

    export default {
        name: 'Footer',
        setup() {
            return {

            }
        }
    }
</script>